
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class SmsGatewaySettingsDialog extends Serenity.EntityDialog<SmsGatewaySettingsRow, any> {
        protected getFormKey() { return SmsGatewaySettingsForm.formKey; }
        protected getIdProperty() { return SmsGatewaySettingsRow.idProperty; }
        protected getLocalTextPrefix() { return SmsGatewaySettingsRow.localTextPrefix; }
        protected getNameProperty() { return SmsGatewaySettingsRow.nameProperty; }
        protected getService() { return SmsGatewaySettingsService.baseUrl; }
        protected getDeletePermission() { return SmsGatewaySettingsRow.deletePermission; }
        protected getInsertPermission() { return SmsGatewaySettingsRow.insertPermission; }
        protected getUpdatePermission() { return SmsGatewaySettingsRow.updatePermission; }

        protected form = new SmsGatewaySettingsForm(this.idPrefix);

    }
}